import{
 createContext,
 useContext,
 useEffect,
 useMemo,
 useState,
 type ReactNode,
}from"react";

export type AppLocale="en"|"de"|"tr";

const EN={
 "nav.security":"Security",
 "nav.operations":"Operations",
 "nav.overview":"Overview",
 "nav.users":"Users",
 "nav.registrations":"Registrations",
 "nav.identityAccess":"Identity & Access",
 "nav.requests":"Requests",
 "nav.devices":"Devices & Passkeys",
 "nav.sessions":"Sessions",
 "nav.vaults":"Vaults",
 "nav.recovery":"Recovery",
 "nav.audit":"Audit",
 "nav.policies":"Policies",
 "nav.settings":"Settings",
 "nav.agentControl":"Agent Control",
 "nav.providerMarket":"Provider Market",
 "nav.repositoryCenter":"Repository & Tool Center",
 "nav.repositories":"Repositories",
 "group.peopleAccess":"People & Access",
 "group.authentication":"Authentication",
 "group.protection":"Protection",
 "group.governance":"Governance",
 "shell.mySecurity":"My Security",
 "shell.administration":"Administration",
 "search.trigger":"Search KNSAIX…",
 "search.title":"Search KNSAIX",
 "search.placeholder":"Pages, operations, settings…",
 "search.empty":"No matching destination.",
 "search.hint":"Type to find pages and operations. Press Enter to open the first result.",
 "search.category.security":"Security",
 "search.category.operations":"Operations",
 "search.category.workspace":"Workspaces",
 "footer.explore":"Explore KNSAIX",
 "footer.security":"Security",
 "footer.operations":"Operations",
 "footer.workspaces":"Other workspaces",
 "footer.search":"Search all KNSAIX",
 "footer.home":"KNSAIX home",
 "footer.backTop":"Back to top",
 "entry.kestraUnavailable":"Kestra unavailable",
 "entry.opencodeUnavailable":"OpenCode unavailable",
 "entry.opendesignUnavailable":"OpenDesign unavailable",
 "footer.language":"Language",
 "language.en":"English",
 "language.de":"Deutsch",
 "language.tr":"Türkçe",
 "a11y.openNavigation":"Open navigation",
 "a11y.closeNavigation":"Close navigation",
 "a11y.globalNavigation":"KNSAIX global navigation",
 "a11y.securityNavigation":"Security navigation",
 "a11y.operationsNavigation":"Operations navigation",
 "operations.subtitle":"Operational AI control and provider management.",
 "sc.center":"Security Center",
 "sc.title":"Security",
 "sc.subtitle":"Understand system security, access and issues at a glance.",
 "sc.refresh":"Refresh",
 "sc.generalState":"General status",
 "sc.healthy":"Healthy",
 "sc.needsAttention":"Needs attention",
 "sc.attentionSummary":"Some security conditions should be reviewed.",
 "sc.noCritical":"No critical issue currently requires action.",
 "sc.statusAreas":"Security status areas",
 "sc.peopleAccess":"People & access",
 "sc.authentication":"Authentication",
 "sc.privilegedAccess":"Privileged access",
 "sc.recovery":"Recovery",
 "sc.activePasskeys":"active passkeys",
 "sc.pending":"pending",
 "sc.noPending":"No pending request",
 "sc.warning":"warning",
 "sc.ready":"Ready",
 "sc.reviewNeeded":"Review recommended",
 "sc.normal":"Normal",
 "sc.priority":"Priority",
 "sc.attention":"Needs your attention",
 "sc.recoveryCoverage":"Recovery coverage",
 "sc.belowUnlock":"identity records are below the unlock minimum.",
 "sc.trustGroups":"Trust groups",
 "sc.singleTrust":"identity records depend on one trust group.",
 "sc.accessRequests":"Access requests",
 "sc.pendingReview":"requests await review.",
 "sc.allClear":"All clear",
 "sc.noAction":"No current security item requires action.",
 "sc.currentState":"Current state",
 "sc.securityControls":"Security controls",
 "sc.adminAuthority":"Admin authority",
 "sc.passkeySession":"Passkey session",
 "sc.unlockCapable":"Unlock-capable passkeys",
 "sc.orgVaults":"Organization vaults",
 "sc.active":"Active",
 "sc.locked":"Locked",
 "sc.required":"Required",
 "sc.authorityRequired":"Administrative authority required",
 "sc.passkeyRequired":"Passkey session required",
 "sc.authorityDetail":"Unlock Security Authority to view privileged organization data.",
 "sc.unlock":"Unlock with passkey",
 "sc.waitingPasskey":"Waiting for passkey…",
 "sc.unlockFailed":"Security Authority unlock failed.",
 "sc.identityHealth":"Identity health",
 "sc.identityHealthy":"Identity and effective access are healthy.",
 "sc.identityNeedsAttention":"This identity has access conditions that need review.",
 "sc.accessProblem":"Access issue detected",
 "sc.principal":"Principal",
 "sc.assignments":"Assignments",
 "sc.allowed":"Allowed",
 "sc.blocked":"Blocked",
 "sc.temporaryAccess":"Temporary access",
 "sc.lidAccess":"LiD access",
 "sc.effectiveAccess":"Effective access",
 "sc.technicalAccess":"All technical permissions",
 "sc.mobileHome":"Home",
 "sc.mobilePeople":"People",
 "sc.mobileAccess":"Access",
 "sc.mobileRequests":"Requests",
 "sc.mobileMore":"More",
 "sc.quickActions":"Quick actions",
 "sc.viewAccess":"View access",
 "sc.addAccess":"Add access",
 "sc.password":"Password",
 "sc.profileTechnical":"Technical side",
 "sc.profileFront":"Profile side",
 "sc.identityType":"Identity type",
 "sc.id":"ID",
 "sc.identitySources":"Identity sources",
 "sc.roles":"Roles",
 "sc.packages":"Packages",
 "sc.open":"Open",
 "sc.dragCards":"Drag to arrange cards",
  "sc.duration15m":"15 min",
  "sc.duration1h":"1 hour",
  "sc.durationToday":"Today",
  "dh.approvalTitle":"Approve sign-in on this computer",
  "dh.approvalBody":"Approve the requested desktop session with your canonical KNSAIX passkey.",
  "dh.approve":"Approve sign-in",
  "dh.approving":"Approving with passkey…",
  "dh.approved":"Computer sign-in approved.",
  "dh.failed":"Approval could not be completed.",
  "auth.signInWithPasskey":"Sign in with passkey",
  "auth.waitingPasskey":"Waiting for passkey…",
  "auth.approveWithAnotherIphone":"Approve with another iPhone",
  "dh.waitingIphone":"Waiting for iPhone approval…",
  "dh.scanQr":"Scan this QR code with your iPhone to approve sign-in.",
  "dh.waitingApproval":"Waiting for approval from iPhone…",
  "dh.completeOnIphone":"Complete the approval on your iPhone.",
  "domain.security_center":"Security Center",
  "domain.crm":"CRM",
  "domain.appointments":"Appointments",
  "domain.field_service":"Field Service",
  "domain.ai_console":"AI Console",
  "domain.provider_market":"Provider Market",
  "domain.accounting":"Accounting",
  "domain.lid":"LID",
  "event.authenticationSucceeded":"Authentication succeeded",
  "event.authenticationFailed":"Authentication failed",
  "event.jitRequested":"JIT access requested",
  "event.jitDecision":"JIT access decision",
  "eventCredentialRenamed":"Credential renamed",
  "eventAuthorityUnlocked":"Security authority unlocked",
  "eventDesktopHandoffApproved":"Desktop handoff approved",
  "eventSessionRevoked":"Session ended",
  "status.healthy":"Healthy",
  "status.degraded":"Degraded",
  "status.critical":"Critical",
  "status.active":"Active",
  "status.expired":"Expired",
  "status.revoked":"Revoked",
  "sc.duration0":"0 min",
  "sc.durationMinutes":"{{count}} min",
  "sc.durationHours":"{{count}} hours",
  "sc.durationDays":"{{count}} days",
  "event.unknown":"Unknown event",
  "status.unknown":"Unknown status",
  "sc.general":"General",
  "sc.generalDesc":"Identity, contact and membership overview.",
  "sc.contact":"Contact",
  "sc.contactDesc":"Verified email and phone for this person.",
  "sc.addresses":"Addresses",
  "sc.addressesDesc":"Recorded postal addresses. Never sourced from CRM.",
  "sc.security":"Security",
  "sc.securityDesc":"Passkeys, sessions and recovery posture.",
  "sc.access":"Access",
  "sc.accessDesc":"Roles, packages and login profile.",
  "sc.activity":"Activity",
  "sc.activityDesc":"Recent security events for this person.",
  "sc.displayName":"Display name",
  "sc.preferredName":"Preferred name",
  "sc.subjectId":"Subject ID",
  "sc.authUserId":"Auth user ID",
  "sc.authStatus":"Auth status",
  "sc.membership":"Membership",
  "sc.organizationRole":"Organization role",
  "sc.joinedAt":"Joined at",
  "sc.securitySummary":"Security summary",
  "sc.status":"Status",
  "sc.locale":"Locale",
  "sc.timezone":"Timezone",
  "sc.passkeys":"Passkeys",
  "sc.sessions":"Sessions",
  "sc.unlockPasskeys":"Unlock passkeys",
  "sc.activeSessions":"Active sessions",
  "sc.recoveryState":"Recovery state",
  "sc.offlineRecovery":"Offline recovery",
  "sc.email":"Email",
  "sc.primaryEmail":"Primary email",
  "sc.emailVerified":"Email verified",
  "sc.emailSource":"Email source",
  "sc.phone":"Phone",
  "sc.primaryPhone":"Primary phone",
  "sc.kind":"Kind",
  "sc.label":"Label",
  "sc.street":"Street",
  "sc.postalCode":"Postal code",
  "sc.city":"City",
  "sc.region":"Region",
  "sc.country":"Country",
  "sc.primary":"Primary",
  "sc.verifiedAt":"Verified at",
  "sc.recordedAddresses":"Recorded addresses",
  "sc.noAddresses":"No addresses",
  "sc.noAddressesDesc":"No postal addresses are recorded for this person.",
  "sc.unnamedPasskey":"Unnamed passkey",
  "sc.canUnlockVault":"Can unlock vault",
  "sc.signInOnly":"Sign-in only",
  "sc.prfCapable":"PRF capable",
  "sc.unknownDevice":"Unknown device",
  "sc.current":"Current",
  "sc.unlockCredentials":"Unlock credentials",
  "sc.loginProfile":"Login profile",
  "sc.profile":"Profile",
  "sc.audience":"Audience",
  "sc.selfRegistration":"Self registration",
  "sc.minAssurance":"Min assurance",
  "sc.sessionMaxAge":"Session max age",
  "sc.time":"Time",
  "sc.event":"Event",
  "sc.resource":"Resource",
  "sc.outcome":"Outcome",
  "sc.severity":"Severity",
  "sc.recentEvents":"Recent events",
  "sc.noEvents":"No events",
  "sc.noEventsDesc":"No recent security events for this person.",
  "sc.notSet":"Not set",
  "sc.notRecorded":"Not recorded",
  "sc.verified":"Verified",
  "sc.yes":"Yes",
  "sc.no":"No",
  "sc.notReady":"Not ready",
  "sc.none":"None",
  "sc.personDetail":"Person Detail",
  "sc.noEmailRecorded":"No email recorded",
  "sc.signInFailed":"Sign in failed",
  "sc.personSections":"Person sections",
  "sc.sessionsTitle":"Sessions",
  "sc.sessionsDesc":"Every sign-in for your organization, with the device, browser, operating system and authentication method that created it.",
  "sc.sessionDevice":"Device",
  "sc.sessionBrowser":"Browser",
  "sc.sessionOs":"Operating system",
  "sc.sessionAuthMethod":"Signed in with",
  "sc.sessionLastActive":"Last active",
  "sc.sessionExpires":"Expires",
  "sc.sessionCreated":"Signed in",
  "sc.sessionRevoked":"Revoked",
  "sc.sessionState":"State",
  "sc.currentSession":"This session",
  "sc.currentSessionBadge":"Current",
  "sc.sessionRevoke":"End session",
  "sc.sessionRevokeConfirm":"End this session?",
  "sc.sessionRevokeHelp":"The person is signed out immediately on every device that holds this session. Their passkeys and vault are not affected.",
  "sc.sessionRevokedSuccess":"Session ended.",
  "sc.sessionRevokeFailed":"The session could not be ended.",
  "sc.sessionRevokeCurrent":"This is your own session. Use sign out to end it.",
  "sc.sessionRevokeInactive":"This session has already ended.",
  "sc.sessionRequiresStepUp":"A fresh passkey approval is required to end somebody else's session.",
  "sc.sessionNoSessions":"No sessions recorded",
  "sc.sessionNoSessionsDesc":"Nobody has signed in to the current organization context yet.",
  "sc.sessionUnknownDevice":"Unknown device",
  "sc.sessionUnknownBrowser":"Unknown browser",
  "sc.sessionUnknownOs":"Unknown operating system",
  "sc.authMethodPasskey":"Passkey",
  "sc.authMethodDesktopHandoff":"Desktop handoff",
  "sc.authMethodPassword":"Password",
  "sc.authMethodUnknown":"Unknown method",
  "sc.clientClassDesktop":"Desktop",
  "sc.clientClassMobile":"Mobile",
  "sc.clientClassTablet":"Tablet",
  "sc.clientClassUnknown":"Unknown device",
  "sc.timeJustNow":"just now",
  "sc.timeMinutesAgo":"{{count}} min ago",
  "sc.timeHoursAgo":"{{count}} h ago",
  "sc.timeDaysAgo":"{{count}} d ago",
  "sc.expiresTomorrow":"Tomorrow",
  "sc.expiresToday":"Today",
  "sc.expiresInDays":"In {{count}} days",
  "sc.sessionNetwork":"Network",
  "sc.sessionPosture":"Device trust",
  "sc.sessionTechnical":"Technical details",
  "sc.sessionTechnicalHelp":"Normalized attribution recorded at sign-in. KNSAIX never stores the raw browser signature or session tokens.",
  "sc.passkeyDetail":"Passkey detail",
  "sc.backToDevices":"Back to devices",
  "sc.openPasskeyDetail":"Open passkey detail",
  "sc.passkeyTypeSynced":"Synced passkey",
  "sc.passkeyTypeDeviceBound":"Device-bound passkey",
  "sc.passkeyTypeHybrid":"Hybrid passkey",
  "sc.passkeyTypeUnknown":"Passkey",
  "sc.rpCurrent":"Current relying party",
  "sc.rpLegacy":"Legacy relying party",
  "sc.rpUnknown":"Unknown relying party",
  "sc.rpProfile":"Relying party",
  "sc.trustTrusted":"Trusted",
  "sc.trustRestricted":"Restricted",
  "sc.trustRevoked":"Revoked",
  "sc.recoveryPrimary":"Primary",
  "sc.recoverySecondary":"Secondary",
  "sc.recoveryRecovery":"Recovery",
  "sc.credentialOrigin":"Enrolled by",
  "sc.createdAt":"Created",
  "sc.lastUsed":"Last used",
  "sc.lastVerified":"Last verified",
  "sc.postureLastSeen":"Device last seen",
  "sc.synced":"Synced",
  "sc.deviceBound":"Device-bound",
  "sc.backedUp":"Backed up",
  "sc.prfCapableShort":"PRF capable",
  "sc.aaguid":"AAGUID",
  "sc.transports":"Transports",
  "sc.rpId":"RP ID",
  "sc.rpName":"RP name",
  "sc.credentialRef":"Credential reference",
  "sc.signCount":"Signature counter",
  "sc.credentialInfo":"Credential information",
  "sc.credentialInfoDesc":"Identifiers recorded for this passkey. No credential material is stored in KNSAIX.",
  "sc.devicePostureTitle":"Device posture",
  "sc.devicePostureDesc":"Posture recorded for the device this passkey authenticates from. Physical device controls are a separate capability.",
  "sc.noDevicePosture":"No device posture recorded",
  "sc.noDevicePostureDesc":"This passkey has no linked device posture. Posture appears after the device is observed during an authentication.",
  "sc.deviceLabel":"Device",
  "sc.platform":"Platform",
  "sc.trustState":"Trust state",
  "sc.recoveryClass":"Recovery class",
  "sc.renamePasskey":"Rename passkey",
  "sc.renamePasskeyHelp":"Change only the display name. Credential material, trust group, PRF state and relying-party binding are never changed.",
  "sc.newName":"New name",
  "sc.changeReason":"Reason for change",
  "sc.changeReasonHint":"Recorded in the security audit log. At least 5 characters.",
  "sc.renameRequiresStepUp":"A fresh passkey approval is required to rename an authenticator.",
  "sc.confirmRename":"Rename with passkey",
  "sc.renamedSuccess":"Passkey renamed.",
  "sc.renameFailed":"Rename could not be completed.",
  "sc.revokeSelfOnly":"Revoke from My Security",
  "sc.revokeSelfOnlyDesc":"KNSAIX only lets a person revoke their own passkey. To remove this authenticator, the owner must confirm with their own passkey from My Security.",
  "sc.lostDeviceUnsupported":"Lost-device recovery is not available yet.",
  "sc.lostDeviceUnsupportedDesc":"No backend flow exists for this. Until one ships, treat a lost device as a rename-and-review case and ask the owner to revoke it from My Security.",
  "sc.personSummary":"Person",
  "sc.noPasskeysRecorded":"No passkeys recorded",
  "sc.noPasskeysRecordedDesc":"No authenticators are registered in the current organization context.",
  "sc.passkeyLoadFailed":"Passkey detail could not be loaded",
  "sc.passkeyNotFound":"Passkey not found",
  "sc.passkeyNotFoundDesc":"This authenticator is not part of the current organization scope.",
  "sc.invalidCredentialId":"Invalid passkey reference",
  "sc.invalidCredentialIdDesc":"This address does not contain a valid passkey reference. Return to the device list and open the passkey from there.",
  "sc.yesShort":"Yes",
  "sc.noShort":"No",
  "sc.backToPeople":"Back to people",
  "sc.openPersonDetail":"Open person detail",
  "sc.unknownPerson":"Unnamed person",
  "sc.personLoadFailed":"Person detail could not be loaded",
  "sc.personLoadFailedDesc":"The request did not complete. Retry, or return to the people list and pick the person again.",
  "sc.personNotFound":"Person not found",
  "sc.personNotFoundDesc":"This person is not part of the current organization scope.",
  "sc.invalidSubjectId":"Invalid person reference",
  "sc.invalidSubjectIdDesc":"This address does not contain a valid person reference. Return to the people list and open the person from there.",
  "sc.retry":"Retry",
  "sc.passkeySessionRequiredTitle":"Passkey session required",
  "sc.passkeySessionRequiredDetail":"Sign in with an approved passkey before opening this view.",
  "sc.authorityRequiredTitle":"Administrative authority required",
  "sc.authorityRequiredDetail":"Unlock Security Authority with fresh passkey approval to view this data.",
  "sc.waitingForPasskey":"Waiting for passkey…",
  "sc.signInWithPasskey":"Sign in with passkey",
  "sc.unlockWithPasskey":"Unlock with passkey",
  "sc.authorityUnlockFailed":"Security Authority unlock failed.",
  "sc.assuranceLevel":"Assurance level",
  "sc.sourcePersonProfile":"Person Profile",
  "sc.sourceAuthUser":"Auth User",
  "sc.sourceNone":"Not recorded",
  "sc.unlinked":"Unlinked",
  "sc.unknown":"Unknown",
  "sc.identity":"Identity",
  "sc.noPasskeys":"No passkeys",
  "sc.noPasskeysDesc":"No passkeys recorded for this person.",
  "sc.noSessions":"No sessions",
  "sc.noSessionsDesc":"No sessions recorded for this person.",
  "sc.noRoles":"No roles assigned",
  "sc.noPackages":"No packages assigned",
  "hps.eyebrow":"HARNESS · PROVIDER CONNECTIONS",
  "hps.title":"Model providers",
  "hps.description":"Connect NVIDIA NIM and OpenRouter once. KNSAIX stores the key encrypted and uses it only inside the Model Gateway.",
  "hps.back":"Back to Harness",
  "hps.refresh":"Refresh",
  "hps.loading":"Loading provider settings…",
  "hps.securityTitle":"How keys are protected",
  "hps.securityBody":"Keys are encrypted with AES-256-GCM, bound to this tenant and provider, and never returned to the browser, written to DSH settings, or placed in a runtime container. Every key change requires a fresh passkey verification.",
  "hps.stepUpNote":"Your browser may ask for your passkey before saving, removing, testing or syncing.",
  "hps.configured":"Key configured",
  "hps.notConfigured":"No key",
  "hps.connected":"Connected",
  "hps.disconnected":"Disconnected",
  "hps.fingerprint":"Key fingerprint",
  "hps.keyVersion":"Key version",
  "hps.lastVerified":"Last verification",
  "hps.never":"Never",
  "hps.saveKey":"Save key",
  "hps.replaceKey":"Replace key",
  "hps.removeKey":"Remove key",
  "hps.test":"Test connection",
  "hps.sync":"Sync models",
  "hps.testing":"Testing connection…",
  "hps.syncing":"Syncing models…",
  "hps.saving":"Saving key…",
  "hps.removing":"Removing key…",
  "hps.keyLabel":"API key",
  "hps.keyPlaceholder":"Paste the provider API key",
  "hps.keyHint":"The key is sent once over HTTPS and stored encrypted. It is never displayed again.",
  "hps.reasonLabel":"Reason",
  "hps.reasonPlaceholder":"Why are you changing this connection?",
  "hps.defaultReason":"Harness provider connection update",
  "hps.cancel":"Cancel",
  "hps.confirmRemoveTitle":"Remove this API key?",
  "hps.confirmRemoveBody":"Harness will stop using this provider until a new key is saved. The provider account itself is not changed.",
  "hps.confirmRemove":"Remove key",
  "hps.saved":"API key saved and catalog sync started.",
  "hps.savedSyncFailed":"API key saved, but the model catalog sync failed. The key remains stored; retry Sync models.",
  "hps.removed":"API key removed.",
  "hps.tested":"Connection test completed.",
  "hps.synced":"Model catalog synchronized.",
  "hps.catalogTitle":"Discovered models",
  "hps.catalogDescription":"Only enabled, verified models appear in the Harness selector. Paid models are never enabled automatically.",
  "hps.catalogEmpty":"No models discovered yet. Save a key or run a sync.",
  "hps.model":"Model",
  "hps.provider":"Provider",
  "hps.allProviders":"All providers",
  "hps.context":"Context",
  "hps.cost":"Cost",
  "hps.free":"Free",
  "hps.paid":"Paid",
  "hps.unknownCost":"Unknown",
  "hps.selectable":"Selectable",
  "hps.notSelectable":"Approval required",
  "hps.lastSync":"Last sync",
  "hps.syncSuccess":"Success",
  "hps.syncFailed":"Failed",
  "hps.syncNever":"Not synced",
  "hps.models":"{count} models",
  "hps.freeCount":"{count} free",
  "hps.paidCount":"{count} paid",
  "hps.unknownCount":"{count} unknown cost",
  "hps.masterKeyMissing":"Server secret master key is not configured. Ask the operator to set KNSAIX_PROVIDER_SECRET_MASTER_KEY.",
  "hps.applyNote":"New models appear in a new Harness session after the runtime is prepared again.",
  "hps.error.auth":"The provider rejected this API key.",
  "hps.error.noKey":"Save an API key before syncing models.",
  "hps.error.network":"The provider catalog could not be reached. The last successful catalog was kept.",
  "hps.error.catalog":"The provider returned an unsupported catalog response. The last successful catalog was kept.",
  "hps.error.masterKey":"Encrypted provider storage is not configured on the server.",
  "hps.error.stepUp":"Passkey verification is required. Unlock Security Authority and try again.",
  "hps.error.permission":"You do not have permission to manage provider connections.",
  "hps.error.generic":"The operation could not be completed.",
}as const;

export type I18nKey=keyof typeof EN;

const DE:Record<I18nKey,string>={
  "a11y.closeNavigation":"Navigation schließen",
  "a11y.globalNavigation":"Globale KNSAIX-Navigation",
  "a11y.openNavigation":"Navigation öffnen",
  "a11y.operationsNavigation":"Betriebsnavigation",
  "a11y.securityNavigation":"Sicherheitsnavigation",
  "auth.approveWithAnotherIphone":"Mit einem anderen iPhone bestätigen",
  "auth.signInWithPasskey":"Mit Passkey anmelden",
  "auth.waitingPasskey":"Warte auf Passkey…",
  "dh.approvalBody":"Bestätigen Sie die angeforderte Desktop-Sitzung mit Ihrem kanonischen KNSAIX-Passkey.",
  "dh.approvalTitle":"Anmeldung an diesem Computer bestätigen",
  "dh.approve":"Anmeldung bestätigen",
  "dh.approved":"Computer-Anmeldung bestätigt.",
  "dh.approving":"Wird mit Passkey bestätigt…",
  "dh.completeOnIphone":"Schließen Sie die Bestätigung auf Ihrem iPhone ab.",
  "dh.failed":"Die Bestätigung konnte nicht abgeschlossen werden.",
  "dh.scanQr":"Scannen Sie diesen QR-Code mit Ihrem iPhone, um die Anmeldung zu bestätigen.",
  "dh.waitingApproval":"Warte auf Bestätigung vom iPhone…",
  "dh.waitingIphone":"Warte auf iPhone-Bestätigung…",
  "domain.accounting":"Rechnungswesen",
  "domain.ai_console":"KI-Konsole",
  "domain.appointments":"Termine",
  "domain.crm":"CRM",
  "domain.field_service":"Außendienst",
  "domain.lid":"VERSCHLUSS",
  "domain.provider_market":"Anbietermarkt",
  "domain.security_center":"Sicherheitszentrum",
  "entry.kestraUnavailable":"Kestra nicht verfügbar",
  "entry.opencodeUnavailable":"OpenCode nicht verfügbar",
  "entry.opendesignUnavailable":"OpenDesign nicht verfügbar",
  "event.authenticationFailed":"Authentifizierung fehlgeschlagen",
  "event.authenticationSucceeded":"Authentifizierung erfolgreich",
  "event.jitDecision":"JIT-Zugriffsentscheidung",
  "event.jitRequested":"JIT-Zugriff angefordert",
  "eventAuthorityUnlocked":"Sicherheitsautorität freigeschaltet",
  "eventCredentialRenamed":"Anmeldeinformationen umbenannt",
  "eventDesktopHandoffApproved":"Desktop-Übergabe genehmigt",
  "eventSessionRevoked":"Sitzung beendet",
  "footer.backTop":"Nach oben",
  "footer.explore":"KNSAIX erkunden",
  "footer.home":"KNSAIX Startseite",
  "footer.language":"Sprache",
  "footer.operations":"Betrieb",
  "footer.search":"Ganz KNSAIX durchsuchen",
  "footer.security":"Sicherheit",
  "footer.workspaces":"Weitere Arbeitsbereiche",
  "group.authentication":"Authentifizierung",
  "group.governance":"Governance",
  "group.peopleAccess":"Personen & Zugriff",
  "group.protection":"Schutz",
  "language.de":"Deutsch",
  "language.en":"English",
  "language.tr":"Türkçe",
  "nav.agentControl":"Agentensteuerung",
  "nav.audit":"Audit",
  "nav.devices":"Geräte & Passkeys",
  "nav.identityAccess":"Identität & Zugriff",
  "nav.operations":"Betrieb",
  "nav.overview":"Übersicht",
  "nav.policies":"Richtlinien",
  "nav.providerMarket":"Provider-Markt",
  "nav.recovery":"Wiederherstellung",
  "nav.registrations":"Registrierungen",
  "nav.repositories":"Repositorys",
  "nav.repositoryCenter":"Repository- und Werkzeugzentrum",
  "nav.requests":"Anfragen",
  "nav.security":"Sicherheit",
  "nav.sessions":"Sitzungen",
  "nav.settings":"Einstellungen",
  "nav.users":"Benutzer",
  "nav.vaults":"Tresore",
  "operations.subtitle":"Operative KI-Steuerung und Provider-Verwaltung.",
  "sc.accessProblem":"Zugriffsproblem erkannt",
  "sc.accessRequests":"Zugriffsanfragen",
  "sc.active":"Aktiv",
  "sc.addAccess":"Zugriff hinzufügen",
  "sc.adminAuthority":"Admin-Autorität",
  "sc.allClear":"Alles in Ordnung",
  "sc.allowed":"Erlaubt",
  "sc.assignments":"Zuweisungen",
  "sc.attention":"Benötigt Ihre Aufmerksamkeit",
  "sc.attentionSummary":"Einige Sicherheitsbedingungen sollten geprüft werden.",
  "sc.authentication":"Authentifizierung",
  "sc.authorityDetail":"Sicherheitsautorität entsperren, um privilegierte Organisationsdaten anzuzeigen.",
  "sc.authorityRequired":"Administrative Autorität erforderlich",
  "sc.belowUnlock":"Identitätsdatensätze liegen unter dem Entsperrminimum.",
  "sc.blocked":"Blockiert",
  "sc.center":"Sicherheitszentrale",
  "sc.currentState":"Aktueller Zustand",
  "sc.dragCards":"Karten zum Anordnen ziehen",
  "sc.duration0":"0 Minuten",
  "sc.duration15m":"15 Min.",
  "sc.duration1h":"1 Stunde",
  "sc.durationDays":"{{count}} Tage",
  "sc.durationHours":"{{count}} Stunden",
  "sc.durationMinutes":"{{count}} Min.",
  "sc.durationToday":"Heute",
  "sc.effectiveAccess":"Effektiver Zugriff",
  "sc.generalState":"Gesamtstatus",
  "sc.healthy":"Gesund",
  "sc.id":"ID",
  "sc.identityHealth":"Identitätszustand",
  "sc.identityHealthy":"Identität und effektiver Zugriff sind in Ordnung.",
  "sc.identityNeedsAttention":"Diese Identität hat Zugriffsbedingungen, die geprüft werden müssen.",
  "sc.identitySources":"Identitätsquellen",
  "sc.identityType":"Identitätstyp",
  "sc.lidAccess":"LiD-Zugriff",
  "sc.locked":"Gesperrt",
  "sc.mobileAccess":"Zugriff",
  "sc.mobileHome":"Start",
  "sc.mobileMore":"Mehr",
  "sc.mobilePeople":"Personen",
  "sc.mobileRequests":"Anfragen",
  "sc.needsAttention":"Aufmerksamkeit erforderlich",
  "sc.noAction":"Kein aktueller Sicherheitspunkt erfordert eine Aktion.",
  "sc.noCritical":"Derzeit erfordert kein kritisches Problem eine Aktion.",
  "sc.noPending":"Keine offene Anfrage",
  "sc.normal":"Normal",
  "sc.open":"Öffnen",
  "sc.orgVaults":"Organisationstresore",
  "sc.packages":"Pakete",
  "sc.passkeyRequired":"Passkey-Sitzung erforderlich",
  "sc.passkeySession":"Passkey-Sitzung",
  "sc.password":"Passwort",
  "sc.pending":"ausstehend",
  "sc.pendingReview":"Anfragen warten auf Prüfung.",
  "sc.peopleAccess":"Personen & Zugriff",
  "sc.principal":"Principal",
  "sc.priority":"Priorität",
  "sc.privilegedAccess":"Privilegierter Zugriff",
  "sc.profileFront":"Profilseite",
  "sc.profileTechnical":"Technische Seite",
  "sc.quickActions":"Schnellaktionen",
  "sc.ready":"Bereit",
  "sc.recovery":"Wiederherstellung",
  "sc.recoveryCoverage":"Wiederherstellungsabdeckung",
  "sc.refresh":"Aktualisieren",
  "sc.required":"Erforderlich",
  "sc.reviewNeeded":"Prüfung empfohlen",
  "sc.roles":"Rollen",
  "sc.securityControls":"Sicherheitskontrollen",
  "sc.singleTrust":"Identitätsdatensätze hängen von einer Vertrauensgruppe ab.",
  "sc.statusAreas":"Sicherheitsstatusbereiche",
  "sc.subtitle":"Systemsicherheit, Zugriff und Probleme auf einen Blick verstehen.",
  "sc.technicalAccess":"Alle technischen Berechtigungen",
  "sc.temporaryAccess":"Temporärer Zugriff",
  "sc.title":"Sicherheit",
  "sc.unlock":"Mit Passkey entsperren",
  "sc.unlockCapable":"Entsperrfähige Passkeys",
  "sc.unlockFailed":"Sicherheitsautorität konnte nicht entsperrt werden.",
  "sc.viewAccess":"Zugriff anzeigen",
  "sc.waitingPasskey":"Warte auf Passkey…",
  "sc.warning":"Warnung",
  "sc.general":"Allgemein",
  "sc.generalDesc":"Identität, Kontakt und Mitgliedschaftsübersicht.",
  "sc.contact":"Kontakt",
  "sc.contactDesc":"Verifizierte E-Mail und Telefon für diese Person.",
  "sc.addresses":"Adressen",
  "sc.addressesDesc":"Erfasste Postadressen. Niemals aus CRM.",
  "sc.security":"Sicherheit",
  "sc.securityDesc":"Passkeys, Sitzungen und Wiederherstellungshaltung.",
  "sc.access":"Zugriff",
  "sc.accessDesc":"Rollen, Pakete und Login-Profil.",
  "sc.activity":"Aktivität",
  "sc.activityDesc":"Letzte Sicherheitsereignisse für diese Person.",
  "sc.displayName":"Anzeigename",
  "sc.preferredName":"Bevorzugter Name",
  "sc.subjectId":"Subjekt-ID",
  "sc.authUserId":"Auth-Benutzer-ID",
  "sc.authStatus":"Auth-Status",
  "sc.membership":"Mitgliedschaft",
  "sc.organizationRole":"Organisationsrolle",
  "sc.joinedAt":"Beigetreten am",
  "sc.securitySummary":"Sicherheitsübersicht",
  "sc.status":"Status",
  "sc.locale":"Locale",
  "sc.timezone":"Zeitzone",
  "sc.passkeys":"Passkeys",
  "sc.sessions":"Sitzungen",
  "sc.activePasskeys":"Aktive Passkeys",
  "sc.unlockPasskeys":"Entsperr-Passkeys",
  "sc.trustGroups":"Vertrauensgruppen",
  "sc.activeSessions":"Aktive Sitzungen",
  "sc.recoveryState":"Wiederherstellungsstatus",
  "sc.offlineRecovery":"Offline-Wiederherstellung",
  "sc.email":"E-Mail",
  "sc.primaryEmail":"Primäre E-Mail",
  "sc.emailVerified":"E-Mail verifiziert",
  "sc.emailSource":"E-Mail-Quelle",
  "sc.phone":"Telefon",
  "sc.primaryPhone":"Primäres Telefon",
  "sc.kind":"Art",
  "sc.label":"Bezeichnung",
  "sc.street":"Straße",
  "sc.postalCode":"Postleitzahl",
  "sc.city":"Stadt",
  "sc.region":"Region",
  "sc.country":"Land",
  "sc.primary":"Primär",
  "sc.verifiedAt":"Verifiziert am",
  "sc.recordedAddresses":"Erfasste Adressen",
  "sc.noAddresses":"Keine Adressen",
  "sc.noAddressesDesc":"Für diese Person sind keine Postadressen erfasst.",
  "sc.unnamedPasskey":"Unbenannter Passkey",
  "sc.canUnlockVault":"Kann Tresor entsperren",
  "sc.signInOnly":"Nur Anmeldung",
  "sc.prfCapable":"PRF-fähig",
  "sc.unknownDevice":"Unbekanntes Gerät",
  "sc.current":"Aktuell",
  "sc.unlockCredentials":"Entsperr-Anmeldeinformationen",
  "sc.loginProfile":"Login-Profil",
  "sc.profile":"Profil",
  "sc.audience":"Zielgruppe",
  "sc.selfRegistration":"Selbstregistrierung",
  "sc.minAssurance":"Min. Assurance",
  "sc.sessionMaxAge":"Max. Sitzungsdauer",
  "sc.time":"Zeit",
  "sc.event":"Ereignis",
  "sc.resource":"Ressource",
  "sc.outcome":"Ergebnis",
  "sc.severity":"Schweregrad",
  "sc.recentEvents":"Letzte Ereignisse",
  "sc.noEvents":"Keine Ereignisse",
  "sc.noEventsDesc":"Keine aktuellen Sicherheitsereignisse für diese Person.",
  "sc.notSet":"Nicht gesetzt",
  "sc.notRecorded":"Nicht erfasst",
  "sc.verified":"Verifiziert",
  "sc.yes":"Ja",
  "sc.no":"Nein",
  "sc.notReady":"Nicht bereit",
  "sc.none":"Keine",
  "sc.personDetail":"Personendetail",
  "sc.noEmailRecorded":"Keine E-Mail erfasst",
  "sc.signInFailed":"Anmeldung fehlgeschlagen",
  "sc.personSections":"Personenbereiche",
  "sc.sessionsTitle":"Sitzungen",
  "sc.sessionsDesc":"Jede Anmeldung Ihrer Organisation mit Gerät, Browser, Betriebssystem und der Authentifizierungsmethode, die sie erzeugt hat.",
  "sc.sessionDevice":"Gerät",
  "sc.sessionBrowser":"Browser",
  "sc.sessionOs":"Betriebssystem",
  "sc.sessionAuthMethod":"Angemeldet mit",
  "sc.sessionLastActive":"Zuletzt aktiv",
  "sc.sessionExpires":"Läuft ab",
  "sc.sessionCreated":"Angemeldet",
  "sc.sessionRevoked":"Widerrufen",
  "sc.sessionState":"Status",
  "sc.currentSession":"Diese Sitzung",
  "sc.currentSessionBadge":"Aktuell",
  "sc.sessionRevoke":"Sitzung beenden",
  "sc.sessionRevokeConfirm":"Diese Sitzung beenden?",
  "sc.sessionRevokeHelp":"Die Person wird auf allen Geräten mit dieser Sitzung sofort abgemeldet. Ihre Passkeys und Tresor bleiben unberührt.",
  "sc.sessionRevokedSuccess":"Sitzung beendet.",
  "sc.sessionRevokeFailed":"Die Sitzung konnte nicht beendet werden.",
  "sc.sessionRevokeCurrent":"Dies ist Ihre eigene Sitzung. Verwenden Sie die Abmeldung, um sie zu beenden.",
  "sc.sessionRevokeInactive":"Diese Sitzung ist bereits beendet.",
  "sc.sessionRequiresStepUp":"Für das Beenden der Sitzung einer anderen Person ist eine frische Passkey-Freigabe erforderlich.",
  "sc.sessionNoSessions":"Keine Sitzungen erfasst",
  "sc.sessionNoSessionsDesc":"Im aktuellen Organisationskontext hat sich noch niemand angemeldet.",
  "sc.sessionUnknownDevice":"Unbekanntes Gerät",
  "sc.sessionUnknownBrowser":"Unbekannter Browser",
  "sc.sessionUnknownOs":"Unbekanntes Betriebssystem",
  "sc.authMethodPasskey":"Passkey",
  "sc.authMethodDesktopHandoff":"Desktop-Übergabe",
  "sc.authMethodPassword":"Passwort",
  "sc.authMethodUnknown":"Unbekannte Methode",
  "sc.clientClassDesktop":"Desktop",
  "sc.clientClassMobile":"Mobil",
  "sc.clientClassTablet":"Tablet",
  "sc.clientClassUnknown":"Unbekanntes Gerät",
  "sc.timeJustNow":"gerade eben",
  "sc.timeMinutesAgo":"vor {{count}} Min.",
  "sc.timeHoursAgo":"vor {{count}} Std.",
  "sc.timeDaysAgo":"vor {{count}} T.",
  "sc.expiresTomorrow":"Morgen",
  "sc.expiresToday":"Heute",
  "sc.expiresInDays":"In {{count}} Tagen",
  "sc.sessionNetwork":"Netzwerk",
  "sc.sessionPosture":"Gerätevertrauen",
  "sc.sessionTechnical":"Technische Details",
  "sc.sessionTechnicalHelp":"Bei der Anmeldung erfasste, normalisierte Zuordnung. KNSAIX speichert weder die rohe Browsersignatur noch Sitzungstoken.",
  "sc.passkeyDetail":"Passkey-Detail",
  "sc.backToDevices":"Zurück zu Geräten",
  "sc.openPasskeyDetail":"Passkey-Detail öffnen",
  "sc.passkeyTypeSynced":"Synchronisierter Passkey",
  "sc.passkeyTypeDeviceBound":"Gerätgebundener Passkey",
  "sc.passkeyTypeHybrid":"Hybrid-Passkey",
  "sc.passkeyTypeUnknown":"Passkey",
  "sc.rpCurrent":"Aktueller Relying Party",
  "sc.rpLegacy":"Alter Relying Party",
  "sc.rpUnknown":"Unbekannter Relying Party",
  "sc.rpProfile":"Relying Party",
  "sc.trustTrusted":"Vertrauenswürdig",
  "sc.trustRestricted":"Eingeschränkt",
  "sc.trustRevoked":"Widerrufen",
  "sc.recoveryPrimary":"Primär",
  "sc.recoverySecondary":"Sekundär",
  "sc.recoveryRecovery":"Wiederherstellung",
  "sc.credentialOrigin":"Registriert von",
  "sc.createdAt":"Erstellt",
  "sc.lastUsed":"Zuletzt verwendet",
  "sc.lastVerified":"Zuletzt geprüft",
  "sc.postureLastSeen":"Gerät zuletzt gesehen",
  "sc.synced":"Synchronisiert",
  "sc.deviceBound":"Gerät gebunden",
  "sc.backedUp":"Gesichert",
  "sc.prfCapableShort":"PRF-fähig",
  "sc.aaguid":"AAGUID",
  "sc.transports":"Transporte",
  "sc.rpId":"RP-ID",
  "sc.rpName":"RP-Name",
  "sc.credentialRef":"Credential-Referenz",
  "sc.signCount":"Signaturzähler",
  "sc.credentialInfo":"Credential-Informationen",
  "sc.credentialInfoDesc":"Für diesen Passkey erfasste Kennungen. In KNSAIX werden keine Credential-Daten gespeichert.",
  "sc.devicePostureTitle":"Gerätestatus",
  "sc.devicePostureDesc":"Status des Geräts, von dem aus sich dieser Passkey authentifiziert. Physische Gerätekontrolle ist eine separate Fähigkeit.",
  "sc.noDevicePosture":"Kein Gerätestatus erfasst",
  "sc.noDevicePostureDesc":"Für diesen Passkey ist kein Gerätestatus verknüpft. Der Status erscheint, nachdem das Gerät bei einer Anmeldung beobachtet wurde.",
  "sc.deviceLabel":"Gerät",
  "sc.platform":"Plattform",
  "sc.trustState":"Vertrauensstatus",
  "sc.recoveryClass":"Wiederherstellungsklasse",
  "sc.renamePasskey":"Passkey umbenennen",
  "sc.renamePasskeyHelp":"Ändert nur den Anzeigenamen. Credential-Daten, Vertrauensgruppe, PRF-Status und Relying-Party-Bindung werden nie geändert.",
  "sc.newName":"Neuer Name",
  "sc.changeReason":"Grund der Änderung",
  "sc.changeReasonHint":"Wird im Sicherheitsprotokoll erfasst. Mindestens 5 Zeichen.",
  "sc.renameRequiresStepUp":"Für das Umbenennen eines Authentifikators ist eine frische Passkey-Freigabe erforderlich.",
  "sc.confirmRename":"Mit Passkey umbenennen",
  "sc.renamedSuccess":"Passkey umbenannt.",
  "sc.renameFailed":"Umbenennen konnte nicht abgeschlossen werden.",
  "sc.revokeSelfOnly":"Über Meine Sicherheit widerrufen",
  "sc.revokeSelfOnlyDesc":"KNSAIX erlaubt nur einer Person, den eigenen Passkey zu widerrufen. Um diesen Authentikator zu entfernen, muss die Eigentümerin oder der Eigentümer in Meine Sicherheit mit dem eigenen Passkey bestätigen.",
  "sc.lostDeviceUnsupported":"Wiederherstellung bei Geräteverlust ist noch nicht verfügbar.",
  "sc.lostDeviceUnsupportedDesc":"Es gibt noch keinen Backend-Ablauf dafür. Bis dahin ein verlorenes Gerät als Umbenennen-und-Prüfen behandeln und die Eigentümerin oder den Eigentümer bitten, es in Meine Sicherheit zu widerrufen.",
  "sc.personSummary":"Person",
  "sc.noPasskeysRecorded":"Keine Passkeys erfasst",
  "sc.noPasskeysRecordedDesc":"Im aktuellen Organisationskontext sind keine Authentifikatoren registriert.",
  "sc.passkeyLoadFailed":"Passkey-Detail konnte nicht geladen werden",
  "sc.passkeyNotFound":"Passkey nicht gefunden",
  "sc.passkeyNotFoundDesc":"Dieser Authentikator gehört nicht zum aktuellen Organisationsbereich.",
  "sc.invalidCredentialId":"Ungültiger Passkey-Verweis",
  "sc.invalidCredentialIdDesc":"Diese Adresse enthält keinen gültigen Passkey-Verweis. Kehren Sie zur Geräteliste zurück und öffnen Sie den Passkey dort.",
  "sc.yesShort":"Ja",
  "sc.noShort":"Nein",
  "sc.backToPeople":"Zurück zu Personen",
  "sc.openPersonDetail":"Personendetail öffnen",
  "sc.unknownPerson":"Unbenannte Person",
  "sc.personLoadFailed":"Personendetail konnte nicht geladen werden",
  "sc.personLoadFailedDesc":"Die Anfrage wurde nicht abgeschlossen. Wiederholen Sie sie oder kehren Sie zur Personenliste zurück.",
  "sc.personNotFound":"Person nicht gefunden",
  "sc.personNotFoundDesc":"Diese Person gehört nicht zum aktuellen Organisationsbereich.",
  "sc.invalidSubjectId":"Ungültiger Personenverweis",
  "sc.invalidSubjectIdDesc":"Diese Adresse enthält keinen gültigen Personenverweis. Kehren Sie zur Personenliste zurück und öffnen Sie die Person dort.",
  "sc.retry":"Wiederholen",
  "sc.passkeySessionRequiredTitle":"Passkey-Sitzung erforderlich",
  "sc.passkeySessionRequiredDetail":"Melden Sie sich mit einem genehmigten Passkey an, bevor Sie diese Ansicht öffnen.",
  "sc.authorityRequiredTitle":"Verwaltungsberechtigung erforderlich",
  "sc.authorityRequiredDetail":"Entsperren Sie die Security Authority mit einer frischen Passkey-Freigabe, um diese Daten anzuzeigen.",
  "sc.waitingForPasskey":"Warten auf Passkey…",
  "sc.signInWithPasskey":"Mit Passkey anmelden",
  "sc.unlockWithPasskey":"Mit Passkey entsperren",
  "sc.authorityUnlockFailed":"Entsperrung der Security Authority fehlgeschlagen.",
  "sc.assuranceLevel":"Sicherheitsstufe",
  "sc.sourcePersonProfile":"Person-Profil",
  "sc.sourceAuthUser":"Auth-Benutzer",
  "sc.sourceNone":"Nicht erfasst",
  "sc.unlinked":"Nicht verknüpft",
  "sc.unknown":"Unbekannt",
  "sc.identity":"Identität",
  "sc.noPasskeys":"Keine Passkeys",
  "sc.noPasskeysDesc":"Für diese Person sind keine Passkeys erfasst.",
  "sc.noSessions":"Keine Sitzungen",
  "sc.noSessionsDesc":"Für diese Person sind keine Sitzungen erfasst.",
  "sc.noRoles":"Keine Rollen zugewiesen",
  "sc.noPackages":"Keine Pakete zugewiesen",
  "search.category.operations":"Betrieb",
  "search.category.security":"Sicherheit",
  "search.category.workspace":"Arbeitsbereiche",
  "search.empty":"Kein passendes Ziel gefunden.",
  "search.hint":"Nach Seiten und Vorgängen suchen. Enter öffnet den ersten Treffer.",
  "search.placeholder":"Seiten, Vorgänge, Einstellungen…",
  "search.title":"KNSAIX durchsuchen",
  "search.trigger":"KNSAIX durchsuchen…",
  "shell.administration":"Administration",
  "shell.mySecurity":"Meine Sicherheit",
  "status.active":"Aktiv",
  "status.critical":"Kritisch",
  "status.degraded":"Degradiert",
  "status.expired":"Abgelaufen",
  "event.unknown":"Unbekanntes Ereignis",
  "status.unknown":"Unbekannter Status",
  "status.healthy":"Gesund",
  "status.revoked":"Widerrufen",
  "hps.eyebrow":"HARNESS · ANBIETERVERBINDUNGEN",
  "hps.title":"Modellanbieter",
  "hps.description":"NVIDIA NIM und OpenRouter einmal verbinden. KNSAIX speichert den Schlüssel verschlüsselt und verwendet ihn nur im Model Gateway.",
  "hps.back":"Zurück zum Harness",
  "hps.refresh":"Aktualisieren",
  "hps.loading":"Anbietereinstellungen werden geladen…",
  "hps.securityTitle":"So werden Schlüssel geschützt",
  "hps.securityBody":"Schlüssel werden mit AES-256-GCM verschlüsselt, an diesen Tenant und Anbieter gebunden und niemals an den Browser zurückgegeben, in DSH-Einstellungen geschrieben oder in einen Runtime-Container gelegt. Jede Schlüsseländerung erfordert eine neue Passkey-Prüfung.",
  "hps.stepUpNote":"Ihr Browser fragt möglicherweise nach Ihrem Passkey, bevor gespeichert, entfernt, getestet oder synchronisiert wird.",
  "hps.configured":"Schlüssel konfiguriert",
  "hps.notConfigured":"Kein Schlüssel",
  "hps.connected":"Verbunden",
  "hps.disconnected":"Nicht verbunden",
  "hps.fingerprint":"Schlüsselfingerabdruck",
  "hps.keyVersion":"Schlüsselversion",
  "hps.lastVerified":"Letzte Prüfung",
  "hps.never":"Nie",
  "hps.saveKey":"Schlüssel speichern",
  "hps.replaceKey":"Schlüssel ersetzen",
  "hps.removeKey":"Schlüssel entfernen",
  "hps.test":"Verbindung testen",
  "hps.sync":"Modelle synchronisieren",
  "hps.testing":"Verbindung wird getestet…",
  "hps.syncing":"Modelle werden synchronisiert…",
  "hps.saving":"Schlüssel wird gespeichert…",
  "hps.removing":"Schlüssel wird entfernt…",
  "hps.keyLabel":"API-Schlüssel",
  "hps.keyPlaceholder":"Anbieter-API-Schlüssel einfügen",
  "hps.keyHint":"Der Schlüssel wird einmal über HTTPS gesendet und verschlüsselt gespeichert. Er wird nie wieder angezeigt.",
  "hps.reasonLabel":"Grund",
  "hps.reasonPlaceholder":"Warum ändern Sie diese Verbindung?",
  "hps.defaultReason":"Harness-Anbieterverbindung aktualisieren",
  "hps.cancel":"Abbrechen",
  "hps.confirmRemoveTitle":"Diesen API-Schlüssel entfernen?",
  "hps.confirmRemoveBody":"Der Harness verwendet diesen Anbieter erst wieder, wenn ein neuer Schlüssel gespeichert ist. Das Anbieterkonto selbst wird nicht geändert.",
  "hps.confirmRemove":"Schlüssel entfernen",
  "hps.saved":"API-Schlüssel gespeichert und Katalogsynchronisierung gestartet.",
  "hps.savedSyncFailed":"API-Schlüssel gespeichert, aber die Katalogsynchronisierung ist fehlgeschlagen. Der Schlüssel bleibt gespeichert; versuchen Sie „Modelle synchronisieren“ erneut.",
  "hps.removed":"API-Schlüssel entfernt.",
  "hps.tested":"Verbindungstest abgeschlossen.",
  "hps.synced":"Modellkatalog synchronisiert.",
  "hps.catalogTitle":"Erkannte Modelle",
  "hps.catalogDescription":"Nur aktivierte, verifizierte Modelle erscheinen in der Harness-Auswahl. Kostenpflichtige Modelle werden nie automatisch aktiviert.",
  "hps.catalogEmpty":"Noch keine Modelle erkannt. Speichern Sie einen Schlüssel oder synchronisieren Sie.",
  "hps.model":"Modell",
  "hps.provider":"Anbieter",
  "hps.allProviders":"Alle Anbieter",
  "hps.context":"Kontext",
  "hps.cost":"Kosten",
  "hps.free":"Kostenlos",
  "hps.paid":"Kostenpflichtig",
  "hps.unknownCost":"Unbekannt",
  "hps.selectable":"Auswählbar",
  "hps.notSelectable":"Freigabe erforderlich",
  "hps.lastSync":"Letzte Synchronisierung",
  "hps.syncSuccess":"Erfolgreich",
  "hps.syncFailed":"Fehlgeschlagen",
  "hps.syncNever":"Nicht synchronisiert",
  "hps.models":"{count} Modelle",
  "hps.freeCount":"{count} kostenlos",
  "hps.paidCount":"{count} kostenpflichtig",
  "hps.unknownCount":"{count} unbekannte Kosten",
  "hps.masterKeyMissing":"Der serverseitige Secret-Master-Schlüssel ist nicht konfiguriert. Der Betreiber muss KNSAIX_PROVIDER_SECRET_MASTER_KEY setzen.",
  "hps.applyNote":"Neue Modelle erscheinen in einer neuen Harness-Sitzung, nachdem die Runtime erneut vorbereitet wurde.",
  "hps.error.auth":"Der Anbieter hat diesen API-Schlüssel abgelehnt.",
  "hps.error.noKey":"Speichern Sie einen API-Schlüssel, bevor Sie Modelle synchronisieren.",
  "hps.error.network":"Der Anbieterkatalog war nicht erreichbar. Der letzte erfolgreiche Katalog bleibt erhalten.",
  "hps.error.catalog":"Der Anbieter hat eine nicht unterstützte Katalogantwort geliefert. Der letzte erfolgreiche Katalog bleibt erhalten.",
  "hps.error.masterKey":"Die verschlüsselte Anbieterspeicherung ist auf dem Server nicht konfiguriert.",
  "hps.error.stepUp":"Eine Passkey-Prüfung ist erforderlich. Entsperren Sie die Security Authority und versuchen Sie es erneut.",
  "hps.error.permission":"Sie dürfen Anbieterverbindungen nicht verwalten.",
  "hps.error.generic":"Der Vorgang konnte nicht abgeschlossen werden.",
 };

const TR:Record<I18nKey,string>={
  "a11y.closeNavigation":"Navigasyonu kapat",
  "a11y.globalNavigation":"KNSAIX global navigasyon",
  "a11y.openNavigation":"Navigasyonu aç",
  "a11y.operationsNavigation":"Operasyon navigasyonu",
  "a11y.securityNavigation":"Güvenlik navigasyonu",
  "auth.approveWithAnotherIphone":"Başka iPhone ile onayla",
  "auth.signInWithPasskey":"Passkey ile giriş",
  "auth.waitingPasskey":"Passkey bekleniyor…",
  "dh.approvalBody":"İstenen masaüstü oturumunu canonical KNSAIX passkey'inizle onaylayın.",
  "dh.approvalTitle":"Bu bilgisayarda oturum açmayı onayla",
  "dh.approve":"Girişi onayla",
  "dh.approved":"Bilgisayar girişi onaylandı.",
  "dh.approving":"Passkey ile onaylanıyor…",
  "dh.completeOnIphone":"Onayı iPhone'unuzda tamamlayın.",
  "dh.failed":"Onay tamamlanamadı.",
  "dh.scanQr":"Girişi onaylamak için bu QR kodu iPhone'unuzla tarayın.",
  "dh.waitingApproval":"iPhone'dan onay bekleniyor…",
  "dh.waitingIphone":"iPhone onayı bekleniyor…",
  "domain.accounting":"Muhasebe",
  "domain.ai_console":"AI Konsolu",
  "domain.appointments":"Randevular",
  "domain.crm":"CRM",
  "domain.field_service":"Saha Hizmeti",
  "domain.lid":"KAPAK",
  "domain.provider_market":"Sağlayıcı Pazarı",
  "domain.security_center":"Güvenlik Merkezi",
  "entry.kestraUnavailable":"Kestra kullanılamıyor",
  "entry.opencodeUnavailable":"OpenCode kullanılamıyor",
  "entry.opendesignUnavailable":"OpenDesign kullanılamıyor",
  "event.authenticationFailed":"Kimlik doğrulaması başarısız oldu",
  "event.authenticationSucceeded":"Kimlik Doğrulama Başarılı",
  "event.jitDecision":"JIT erişim kararı",
  "event.jitRequested":"JIT erişimi istendi",
  "eventAuthorityUnlocked":"Güvenlik yetkisinin kilidi açıldı",
  "eventCredentialRenamed":"Kimlik bilgisi yeniden adlandırıldı",
  "eventDesktopHandoffApproved":"Masaüstü teslimatı onaylandı",
  "eventSessionRevoked":"Oturum sonlandırıldı",
  "footer.backTop":"Yukarı dön",
  "footer.explore":"KNSAIX'i keşfet",
  "footer.home":"KNSAIX ana sayfa",
  "footer.language":"Dil",
  "footer.operations":"Operasyonlar",
  "footer.search":"Tüm KNSAIX'te ara",
  "footer.security":"Güvenlik",
  "footer.workspaces":"Diğer çalışma alanları",
  "group.authentication":"Kimlik Doğrulama",
  "group.governance":"Yönetişim",
  "group.peopleAccess":"Kullanıcılar & Erişim",
  "group.protection":"Koruma",
  "language.de":"Deutsch",
  "language.en":"English",
  "language.tr":"Türkçe",
  "nav.agentControl":"Agent Control",
  "nav.audit":"Denetim",
  "nav.devices":"Cihazlar & Passkey'ler",
  "nav.identityAccess":"Kimlik & Erişim",
  "nav.operations":"Operasyonlar",
  "nav.overview":"Genel Bakış",
  "nav.policies":"Politikalar",
  "nav.providerMarket":"Provider Market",
  "nav.recovery":"Kurtarma",
  "nav.registrations":"Kayıtlar",
  "nav.repositories":"Depolar",
  "nav.repositoryCenter":"Depo ve Araç Merkezi",
  "nav.requests":"İstekler",
  "nav.security":"Güvenlik",
  "nav.sessions":"Oturumlar",
  "nav.settings":"Ayarlar",
  "nav.users":"Kullanıcılar",
  "nav.vaults":"Kasalar",
  "operations.subtitle":"Operasyonel AI kontrolü ve sağlayıcı yönetimi.",
  "sc.accessProblem":"Erişim sorunu tespit edildi",
  "sc.accessRequests":"Erişim istekleri",
  "sc.active":"Aktif",
  "sc.addAccess":"Yetki ekle",
  "sc.adminAuthority":"Yönetim otoritesi",
  "sc.allClear":"Her şey yolunda",
  "sc.allowed":"İzinli",
  "sc.assignments":"Atamalar",
  "sc.attention":"Dikkat gerekenler",
  "sc.attentionSummary":"Bazı güvenlik koşullarının incelenmesi gerekiyor.",
  "sc.authentication":"Kimlik doğrulama",
  "sc.authorityDetail":"Ayrıcalıklı organizasyon verilerini görmek için Güvenlik Otoritesini açın.",
  "sc.authorityRequired":"Yönetim otoritesi gerekli",
  "sc.belowUnlock":"kimlik kaydı kilit açma minimumunun altında.",
  "sc.blocked":"Engelli",
  "sc.center":"Güvenlik Merkezi",
  "sc.currentState":"Mevcut durum",
  "sc.dragCards":"Kartları düzenlemek için sürükle",
  "sc.duration0":"0 dk",
  "sc.duration15m":"15 dk",
  "sc.duration1h":"1 saat",
  "sc.durationDays":"{{count}} gün",
  "sc.durationHours":"{{count}} saat",
  "sc.durationMinutes":"{{count}} dk.",
  "sc.durationToday":"Bugün",
  "sc.effectiveAccess":"Etkin erişim",
  "sc.generalState":"Genel durum",
  "sc.healthy":"Sağlıklı",
  "sc.id":"Kimlik ID",
  "sc.identityHealth":"Kimlik sağlığı",
  "sc.identityHealthy":"Kimlik ve etkin erişim sağlıklı.",
  "sc.identityNeedsAttention":"Bu kimliğin incelenmesi gereken erişim koşulları var.",
  "sc.identitySources":"Kimlik kaynakları",
  "sc.identityType":"Kimlik türü",
  "sc.lidAccess":"LiD erişimi",
  "sc.locked":"Kilitli",
  "sc.mobileAccess":"Erişim",
  "sc.mobileHome":"Ana Sayfa",
  "sc.mobileMore":"Daha Fazla",
  "sc.mobilePeople":"Kullanıcılar",
  "sc.mobileRequests":"İstekler",
  "sc.needsAttention":"Dikkat gerekiyor",
  "sc.noAction":"Şu anda işlem gerektiren güvenlik öğesi yok.",
  "sc.noCritical":"Şu anda işlem gerektiren kritik sorun yok.",
  "sc.noPending":"Bekleyen istek yok",
  "sc.normal":"Normal",
  "sc.open":"Aç",
  "sc.orgVaults":"Organizasyon kasaları",
  "sc.packages":"Paketler",
  "sc.passkeyRequired":"Passkey oturumu gerekli",
  "sc.passkeySession":"Passkey oturumu",
  "sc.password":"Parola",
  "sc.pending":"bekliyor",
  "sc.pendingReview":"istek inceleme bekliyor.",
  "sc.peopleAccess":"Kullanıcılar & erişim",
  "sc.principal":"Kimlik",
  "sc.priority":"Öncelik",
  "sc.privilegedAccess":"Ayrıcalıklı erişim",
  "sc.profileFront":"Profil yüzü",
  "sc.profileTechnical":"Teknik yüz",
  "sc.quickActions":"Hızlı işlemler",
  "sc.ready":"Hazır",
  "sc.recovery":"Kurtarma",
  "sc.recoveryCoverage":"Kurtarma kapsamı",
  "sc.refresh":"Yenile",
  "sc.required":"Gerekli",
  "sc.reviewNeeded":"İnceleme öneriliyor",
  "sc.roles":"Roller",
  "sc.securityControls":"Güvenlik kontrolleri",
  "sc.singleTrust":"kimlik kaydı tek güven grubuna bağlı.",
  "sc.statusAreas":"Güvenlik durum alanları",
  "sc.subtitle":"Sistem güvenliğini, erişimi ve sorunları tek bakışta anlayın.",
  "sc.technicalAccess":"Tüm teknik yetkiler",
  "sc.temporaryAccess":"Geçici erişim",
  "sc.title":"Güvenlik",
  "sc.unlock":"Passkey ile kilidi aç",
  "sc.unlockCapable":"Kilit açabilen passkey'ler",
  "sc.unlockFailed":"Güvenlik Otoritesi açılamadı.",
  "sc.viewAccess":"Erişimi gör",
  "sc.waitingPasskey":"Passkey bekleniyor…",
  "sc.warning":"uyarı",
  "sc.general":"Genel",
  "sc.generalDesc":"Kimlik, iletişim ve üyelik genel bakışı.",
  "sc.contact":"İletişim",
  "sc.contactDesc":"Bu kişi için doğrulanmış e-posta ve telefon.",
  "sc.addresses":"Adresler",
  "sc.addressesDesc":"Kayıtlı posta adresleri. CRM'den asla alınmaz.",
  "sc.security":"Güvenlik",
  "sc.securityDesc":"Passkey'ler, oturumlar ve kurtarma durumu.",
  "sc.access":"Erişim",
  "sc.accessDesc":"Roller, paketler ve giriş profili.",
  "sc.activity":"Aktivite",
  "sc.activityDesc":"Bu kişi için son güvenlik olayları.",
  "sc.displayName":"Görünen ad",
  "sc.preferredName":"Tercih edilen ad",
  "sc.subjectId":"Kimlik ID",
  "sc.authUserId":"Auth kullanıcı ID",
  "sc.authStatus":"Auth durumu",
  "sc.membership":"Üyelik",
  "sc.organizationRole":"Organizasyon rolü",
  "sc.joinedAt":"Katılma tarihi",
  "sc.securitySummary":"Güvenlik özeti",
  "sc.status":"Durum",
  "sc.locale":"Yerel",
  "sc.timezone":"Zaman dilimi",
  "sc.passkeys":"Passkey'ler",
  "sc.sessions":"Oturumlar",
  "sc.activePasskeys":"Aktif passkey'ler",
  "sc.unlockPasskeys":"Kilit açan passkey'ler",
  "sc.trustGroups":"Güven grupları",
  "sc.activeSessions":"Aktif oturumlar",
  "sc.recoveryState":"Kurtarma durumu",
  "sc.offlineRecovery":"Çevrimdışı kurtarma",
  "sc.email":"E-posta",
  "sc.primaryEmail":"Birincil e-posta",
  "sc.emailVerified":"E-posta doğrulandı",
  "sc.emailSource":"E-posta kaynağı",
  "sc.phone":"Telefon",
  "sc.primaryPhone":"Birincil telefon",
  "sc.kind":"Tür",
  "sc.label":"Etiket",
  "sc.street":"Sokak",
  "sc.postalCode":"Posta kodu",
  "sc.city":"Şehir",
  "sc.region":"Bölge",
  "sc.country":"Ülke",
  "sc.primary":"Birincil",
  "sc.verifiedAt":"Doğrulama tarihi",
  "sc.recordedAddresses":"Kayıtlı adresler",
  "sc.noAddresses":"Adres yok",
  "sc.noAddressesDesc":"Bu kişi için hiç posta adresi kaydedilmemiş.",
  "sc.unnamedPasskey":"İsimsiz passkey",
  "sc.canUnlockVault":"Kasayı açabilir",
  "sc.signInOnly":"Sadece giriş",
  "sc.prfCapable":"PRF yetenekli",
  "sc.unknownDevice":"Bilinmeyen cihaz",
  "sc.current":"Mevcut",
  "sc.unlockCredentials":"Kilit açma kimlik bilgileri",
  "sc.loginProfile":"Giriş profili",
  "sc.profile":"Profil",
  "sc.audience":"Kitle",
  "sc.selfRegistration":"Kendi kayıt",
  "sc.minAssurance":"Min güvenlik",
  "sc.sessionMaxAge":"Max oturum süresi",
  "sc.time":"Zaman",
  "sc.event":"Olay",
  "sc.resource":"Kaynak",
  "sc.outcome":"Sonuç",
  "sc.severity":"Şiddet",
  "sc.recentEvents":"Son olaylar",
  "sc.noEvents":"Olay yok",
  "sc.noEventsDesc":"Bu kişi için son güvenlik olayı yok.",
  "sc.notSet":"Ayarlanmamış",
  "sc.notRecorded":"Kayıtlı değil",
  "sc.verified":"Doğrulandı",
  "sc.yes":"Evet",
  "sc.no":"Hayır",
  "sc.notReady":"Hazır değil",
  "sc.none":"Yok",
  "sc.personDetail":"Kişi Detayı",
  "sc.noEmailRecorded":"E-posta kaydı yok",
  "sc.signInFailed":"Giriş başarısız",
  "sc.personSections":"Kişi bölümleri",
  "sc.sessionsTitle":"Oturumlar",
  "sc.sessionsDesc":"Kuruluşunuzdaki her oturum açma; cihaz, tarayıcı, işletim sistemi ve oturumu oluşturan kimlik doğrulama yöntemiyle birlikte.",
  "sc.sessionDevice":"Cihaz",
  "sc.sessionBrowser":"Tarayıcı",
  "sc.sessionOs":"İşletim sistemi",
  "sc.sessionAuthMethod":"Giriş yöntemi",
  "sc.sessionLastActive":"Son etkinlik",
  "sc.sessionExpires":"Bitiş",
  "sc.sessionCreated":"Giriş",
  "sc.sessionRevoked":"İptal edildi",
  "sc.sessionState":"Durum",
  "sc.currentSession":"Bu oturum",
  "sc.currentSessionBadge":"Aktif",
  "sc.sessionRevoke":"Oturumu sonlandır",
  "sc.sessionRevokeConfirm":"Bu oturum sonlandırılsın mı?",
  "sc.sessionRevokeHelp":"Kişinin bu oturumu taşıyan tüm cihazlarda hemen oturumu kapatılır. Passkey’leri ve kasası etkilenmez.",
  "sc.sessionRevokedSuccess":"Oturum sonlandırıldı.",
  "sc.sessionRevokeFailed":"Oturum sonlandırılamadı.",
  "sc.sessionRevokeCurrent":"Bu kendi oturumunuz. Sonlandırmak için çıkış yapın.",
  "sc.sessionRevokeInactive":"Bu oturum zaten sonlanmış.",
  "sc.sessionRequiresStepUp":"Başka birinin oturumunu sonlandırmak için yeni bir passkey onayı gerekir.",
  "sc.sessionNoSessions":"Kayıtlı oturum yok",
  "sc.sessionNoSessionsDesc":"Geçerli organizasyon bağlamında henüz kimse oturum açmadı.",
  "sc.sessionUnknownDevice":"Bilinmeyen cihaz",
  "sc.sessionUnknownBrowser":"Bilinmeyen tarayıcı",
  "sc.sessionUnknownOs":"Bilinmeyen işletim sistemi",
  "sc.authMethodPasskey":"Passkey",
  "sc.authMethodDesktopHandoff":"Masaüstü devretme",
  "sc.authMethodPassword":"Parola",
  "sc.authMethodUnknown":"Bilinmeyen yöntem",
  "sc.clientClassDesktop":"Masaüstü",
  "sc.clientClassMobile":"Mobil",
  "sc.clientClassTablet":"Tablet",
  "sc.clientClassUnknown":"Bilinmeyen cihaz",
  "sc.timeJustNow":"az önce",
  "sc.timeMinutesAgo":"{{count}} dk önce",
  "sc.timeHoursAgo":"{{count}} sa önce",
  "sc.timeDaysAgo":"{{count}} gün önce",
  "sc.expiresTomorrow":"Yarın",
  "sc.expiresToday":"Bugün",
  "sc.expiresInDays":"{{count}} gün içinde",
  "sc.sessionNetwork":"Ağ",
  "sc.sessionPosture":"Cihaz güveni",
  "sc.sessionTechnical":"Teknik ayrıntılar",
  "sc.sessionTechnicalHelp":"Giriş sırasında kaydedilen normalleştirilmiş nitelikler. KNSAIX ham tarayıcı imzasını veya oturum belirteçlerini saklamaz.",
  "sc.passkeyDetail":"Passkey detayı",
  "sc.backToDevices":"Cihazlara dön",
  "sc.openPasskeyDetail":"Passkey detayını aç",
  "sc.passkeyTypeSynced":"Eşitlenmiş passkey",
  "sc.passkeyTypeDeviceBound":"Cihaza bağlı passkey",
  "sc.passkeyTypeHybrid":"Hibrit passkey",
  "sc.passkeyTypeUnknown":"Passkey",
  "sc.rpCurrent":"Geçerli relying party",
  "sc.rpLegacy":"Eski relying party",
  "sc.rpUnknown":"Bilinmeyen relying party",
  "sc.rpProfile":"Relying party",
  "sc.trustTrusted":"Güvenilir",
  "sc.trustRestricted":"Kısıtlı",
  "sc.trustRevoked":"İptal edildi",
  "sc.recoveryPrimary":"Birincil",
  "sc.recoverySecondary":"İkincil",
  "sc.recoveryRecovery":"Kurtarma",
  "sc.credentialOrigin":"Kaydeden",
  "sc.createdAt":"Oluşturulma",
  "sc.lastUsed":"Son kullanım",
  "sc.lastVerified":"Son doğrulama",
  "sc.postureLastSeen":"Cihaz son görülme",
  "sc.synced":"Eşitlendi",
  "sc.deviceBound":"Cihaza bağlı",
  "sc.backedUp":"Yedeklendi",
  "sc.prfCapableShort":"PRF destekler",
  "sc.aaguid":"AAGUID",
  "sc.transports":"Taşımalar",
  "sc.rpId":"RP ID",
  "sc.rpName":"RP adı",
  "sc.credentialRef":"Credential referansı",
  "sc.signCount":"İmza sayacı",
  "sc.credentialInfo":"Credential bilgileri",
  "sc.credentialInfoDesc":"Bu passkey için kaydedilen tanımlayıcılar. KNSAIX hiçbir credential materyali saklamaz.",
  "sc.devicePostureTitle":"Cihaz durumu",
  "sc.devicePostureDesc":"Bu passkey’in kimlik doğrulama yaptığı cihazın durumu. Fiziksel cihaz kontrolleri ayrı bir yetenektir.",
  "sc.noDevicePosture":"Cihaz durumu kaydı yok",
  "sc.noDevicePostureDesc":"Bu passkey’e bağlı cihaz durumu yok. Durum, bir kimlik doğrulama sırasında cihaz gözlendikten sonra görünür.",
  "sc.deviceLabel":"Cihaz",
  "sc.platform":"Platform",
  "sc.trustState":"Güven durumu",
  "sc.recoveryClass":"Kurtarma sınıfı",
  "sc.renamePasskey":"Passkey’i yeniden adlandır",
  "sc.renamePasskeyHelp":"Yalnızca görünen adı değiştirir. Credential materyali, güven grubu, PRF durumu ve relying party bağlantısı asla değişmez.",
  "sc.newName":"Yeni ad",
  "sc.changeReason":"Değişiklik nedeni",
  "sc.changeReasonHint":"Güvenlik denetim kaydına yazılır. En az 5 karakter.",
  "sc.renameRequiresStepUp":"Bir kimlik doğrulayıcıyı yeniden adlandırmak için yeni bir passkey onayı gerekir.",
  "sc.confirmRename":"Passkey ile yeniden adlandır",
  "sc.renamedSuccess":"Passkey yeniden adlandırıldı.",
  "sc.renameFailed":"Yeniden adlandırma tamamlanamadı.",
  "sc.revokeSelfOnly":"Kişisel Güvenlikten iptal et",
  "sc.revokeSelfOnlyDesc":"KNSAIX yalnızca bir kişinin kendi passkey’ini iptal etmesine izin verir. Bu kimlik doğrulayıcıyı kaldırmak için sahibi, Kişisel Güvenlik ekranından kendi passkey’i ile onaylamalıdır.",
  "sc.lostDeviceUnsupported":"Kayıp cihaz kurtarma henüz mevcut değil.",
  "sc.lostDeviceUnsupportedDesc":"Bunun için bir arka uç akışı yok. Akış gelene kadar kayıp cihazı yeniden adlandır ve incele durumu olarak ele alın ve sahibinden Kişisel Güvenlik üzerinden iptal etmesini isteyin.",
  "sc.personSummary":"Kişi",
  "sc.noPasskeysRecorded":"Kayıtlı passkey yok",
  "sc.noPasskeysRecordedDesc":"Geçerli organizasyon bağlamında hiçbir kimlik doğrulayıcı kayıtlı değil.",
  "sc.passkeyLoadFailed":"Passkey detayı yüklenemedi",
  "sc.passkeyNotFound":"Passkey bulunamadı",
  "sc.passkeyNotFoundDesc":"Bu kimlik doğrulayıcı geçerli organizasyon kapsamına dahil değil.",
  "sc.invalidCredentialId":"Geçersiz passkey referansı",
  "sc.invalidCredentialIdDesc":"Bu adres geçerli bir passkey referansı içermiyor. Cihaz listesine dönün ve passkey’i oradan açın.",
  "sc.yesShort":"Evet",
  "sc.noShort":"Hayır",
  "sc.backToPeople":"Kişilere dön",
  "sc.openPersonDetail":"Kişi detayını aç",
  "sc.unknownPerson":"Adsız kişi",
  "sc.personLoadFailed":"Kişi detayı yüklenemedi",
  "sc.personLoadFailedDesc":"İstek tamamlanamadı. Yeniden deneyin veya kişi listesine dönüp kişiyi oradan seçin.",
  "sc.personNotFound":"Kişi bulunamadı",
  "sc.personNotFoundDesc":"Bu kişi geçerli organizasyon kapsamına dahil değil.",
  "sc.invalidSubjectId":"Geçersiz kişi referansı",
  "sc.invalidSubjectIdDesc":"Bu adres geçerli bir kişi referansı içermiyor. Kişi listesine dönün ve kişiyi oradan açın.",
  "sc.retry":"Yeniden dene",
  "sc.passkeySessionRequiredTitle":"Passkey oturumu gerekli",
  "sc.passkeySessionRequiredDetail":"Bu görünümü açmadan önce onaylı bir passkey ile oturum açın.",
  "sc.authorityRequiredTitle":"Yönetim yetkisi gerekli",
  "sc.authorityRequiredDetail":"Bu verileri görmek için Security Authority kilidini yeni bir passkey onayı ile açın.",
  "sc.waitingForPasskey":"Passkey bekleniyor…",
  "sc.signInWithPasskey":"Passkey ile oturum aç",
  "sc.unlockWithPasskey":"Passkey ile kilidi aç",
  "sc.authorityUnlockFailed":"Security Authority kilidi açılamadı.",
  "sc.assuranceLevel":"Güvenlik düzeyi",
  "sc.sourcePersonProfile":"Kişi Profili",
  "sc.sourceAuthUser":"Auth Kullanıcısı",
  "sc.sourceNone":"Kayıt yok",
  "sc.unlinked":"Bağlı değil",
  "sc.unknown":"Bilinmiyor",
  "sc.identity":"Kimlik",
  "sc.noPasskeys":"Passkey yok",
  "sc.noPasskeysDesc":"Bu kişi için passkey kaydı yok.",
  "sc.noSessions":"Oturum yok",
  "sc.noSessionsDesc":"Bu kişi için oturum kaydı yok.",
  "sc.noRoles":"Rol atanmamış",
  "sc.noPackages":"Paket atanmamış",
  "search.category.operations":"Operasyonlar",
  "search.category.security":"Güvenlik",
  "search.category.workspace":"Çalışma alanları",
  "search.empty":"Eşleşen hedef bulunamadı.",
  "search.hint":"Sayfa ve operasyon arayın. İlk sonucu açmak için Enter'a basın.",
  "search.placeholder":"Sayfalar, operasyonlar, ayarlar…",
  "search.title":"KNSAIX'te ara",
  "search.trigger":"KNSAIX'te ara…",
  "shell.administration":"Yönetim",
  "shell.mySecurity":"Güvenliğim",
  "status.active":"Aktif",
  "status.critical":"Kritik",
  "event.unknown":"Bilinmeyen etkinlik",
  "status.unknown":"Bilinmeyen durum",
  "status.degraded":"Değeri düşürülmüş",
  "status.expired":"Süresi doldu",
  "status.healthy":"Sağlıklı",
  "status.revoked":"Geri çekilmiş",
  "hps.eyebrow":"HARNESS · SAĞLAYICI BAĞLANTILARI",
  "hps.title":"Model sağlayıcıları",
  "hps.description":"NVIDIA NIM ve OpenRouter bağlantısını bir kez kurun. KNSAIX anahtarı şifreli saklar ve yalnızca Model Gateway içinde kullanır.",
  "hps.back":"Harness'a dön",
  "hps.refresh":"Yenile",
  "hps.loading":"Sağlayıcı ayarları yükleniyor…",
  "hps.securityTitle":"Anahtarlar nasıl korunur",
  "hps.securityBody":"Anahtarlar AES-256-GCM ile şifrelenir, bu tenant ve sağlayıcıya bağlanır; tarayıcıya geri döndürülmez, DSH ayarlarına yazılmaz ve runtime container'ına konmaz. Her anahtar değişikliği yeni bir passkey doğrulaması gerektirir.",
  "hps.stepUpNote":"Kaydetme, kaldırma, test veya senkronizasyon öncesinde tarayıcınız passkey isteyebilir.",
  "hps.configured":"Anahtar tanımlı",
  "hps.notConfigured":"Anahtar yok",
  "hps.connected":"Bağlı",
  "hps.disconnected":"Bağlı değil",
  "hps.fingerprint":"Anahtar parmak izi",
  "hps.keyVersion":"Anahtar sürümü",
  "hps.lastVerified":"Son doğrulama",
  "hps.never":"Hiç",
  "hps.saveKey":"Anahtarı kaydet",
  "hps.replaceKey":"Anahtarı değiştir",
  "hps.removeKey":"Anahtarı kaldır",
  "hps.test":"Bağlantıyı test et",
  "hps.sync":"Modelleri eşitle",
  "hps.testing":"Bağlantı test ediliyor…",
  "hps.syncing":"Modeller eşitleniyor…",
  "hps.saving":"Anahtar kaydediliyor…",
  "hps.removing":"Anahtar kaldırılıyor…",
  "hps.keyLabel":"API anahtarı",
  "hps.keyPlaceholder":"Sağlayıcı API anahtarını yapıştırın",
  "hps.keyHint":"Anahtar HTTPS üzerinden bir kez gönderilir ve şifreli saklanır. Bir daha gösterilmez.",
  "hps.reasonLabel":"Gerekçe",
  "hps.reasonPlaceholder":"Bu bağlantıyı neden değiştiriyorsunuz?",
  "hps.defaultReason":"Harness sağlayıcı bağlantısını güncelle",
  "hps.cancel":"Vazgeç",
  "hps.confirmRemoveTitle":"Bu API anahtarı kaldırılsın mı?",
  "hps.confirmRemoveBody":"Yeni bir anahtar kaydedilene kadar Harness bu sağlayıcıyı kullanmaz. Sağlayıcı hesabı değişmez.",
  "hps.confirmRemove":"Anahtarı kaldır",
  "hps.saved":"API anahtarı kaydedildi ve katalog eşitlemesi başladı.",
  "hps.savedSyncFailed":"API anahtarı kaydedildi ancak model kataloğu eşitlenemedi. Anahtar saklı kaldı; Modelleri eşitle işlemini yeniden deneyin.",
  "hps.removed":"API anahtarı kaldırıldı.",
  "hps.tested":"Bağlantı testi tamamlandı.",
  "hps.synced":"Model kataloğu eşitlendi.",
  "hps.catalogTitle":"Keşfedilen modeller",
  "hps.catalogDescription":"Harness seçicisinde yalnızca etkin ve doğrulanmış modeller görünür. Ücretli modeller otomatik etkinleştirilmez.",
  "hps.catalogEmpty":"Henüz model keşfedilmedi. Bir anahtar kaydedin veya eşitleme çalıştırın.",
  "hps.model":"Model",
  "hps.provider":"Sağlayıcı",
  "hps.allProviders":"Tüm sağlayıcılar",
  "hps.context":"Bağlam",
  "hps.cost":"Ücret",
  "hps.free":"Ücretsiz",
  "hps.paid":"Ücretli",
  "hps.unknownCost":"Bilinmiyor",
  "hps.selectable":"Seçilebilir",
  "hps.notSelectable":"Onay gerekli",
  "hps.lastSync":"Son eşitleme",
  "hps.syncSuccess":"Başarılı",
  "hps.syncFailed":"Başarısız",
  "hps.syncNever":"Eşitlenmedi",
  "hps.models":"{count} model",
  "hps.freeCount":"{count} ücretsiz",
  "hps.paidCount":"{count} ücretli",
  "hps.unknownCount":"{count} ücreti bilinmeyen",
  "hps.masterKeyMissing":"Sunucu secret master anahtarı tanımlı değil. Operatör KNSAIX_PROVIDER_SECRET_MASTER_KEY değerini ayarlamalı.",
  "hps.applyNote":"Yeni modeller, runtime yeniden hazırlandıktan sonra yeni Harness oturumunda görünür.",
  "hps.error.auth":"Sağlayıcı bu API anahtarını reddetti.",
  "hps.error.noKey":"Modelleri eşitlemeden önce bir API anahtarı kaydedin.",
  "hps.error.network":"Sağlayıcı kataloğuna ulaşılamadı. Son başarılı katalog korundu.",
  "hps.error.catalog":"Sağlayıcı desteklenmeyen bir katalog yanıtı döndürdü. Son başarılı katalog korundu.",
  "hps.error.masterKey":"Şifreli sağlayıcı deposu sunucuda yapılandırılmamış.",
  "hps.error.stepUp":"Passkey doğrulaması gerekli. Security Authority'yi açın ve yeniden deneyin.",
  "hps.error.permission":"Sağlayıcı bağlantılarını yönetme yetkiniz yok.",
  "hps.error.generic":"İşlem tamamlanamadı.",
 };

const MESSAGES:Record<AppLocale,Record<I18nKey,string>>={
 en:EN,
 de:DE,
 tr:TR,
};

function browserLocale():AppLocale{
 if(typeof window==="undefined")return"en";
 const saved=window.localStorage.getItem("knsaix.locale");
 if(saved==="en"||saved==="de"||saved==="tr")return saved;
 const lang=(window.navigator.language||"en").toLowerCase();
 if(lang.startsWith("de"))return"de";
 if(lang.startsWith("tr"))return"tr";
 return"en";
}

export interface I18nContextValue{
  locale:AppLocale;
  setLocale:(locale:AppLocale)=>void;
  t:(key:I18nKey|string)=>string;
  formatDate:(value:string|Date|null|undefined,options?:Intl.DateTimeFormatOptions)=>string;
  formatNumber:(value:number,options?:Intl.NumberFormatOptions)=>string;
}

export const AppI18nContext=createContext<I18nContextValue|null>(null);

export function AppI18nProvider({children}:{children:ReactNode}){
 const[locale,setLocaleState]=useState<AppLocale>(browserLocale);

 const setLocale=(next:AppLocale)=>{
  setLocaleState(next);
  if(typeof window!=="undefined")window.localStorage.setItem("knsaix.locale",next);
 };

 useEffect(()=>{
  if(typeof document!=="undefined")document.documentElement.lang=locale;
 },[locale]);

 const value=useMemo<I18nContextValue>(()=>({
  locale,
  setLocale,
  t:((key:string): string => { const v = MESSAGES[locale][key as I18nKey]??MESSAGES.en[key as I18nKey]??key; return typeof v === 'string' ? v : String(v); }),
  formatDate:(value,options)=>{
   if(!value)return"—";
   const date=value instanceof Date?value:new Date(value);
   if(Number.isNaN(date.getTime()))return String(value);
   return new Intl.DateTimeFormat(locale,{
    dateStyle:"medium",
    timeStyle:"short",
    ...options,
   }).format(date);
  },
  formatNumber:(value,options)=>new Intl.NumberFormat(locale,options).format(value),
 }),[locale]);

 return <AppI18nContext.Provider value={value}>{children}</AppI18nContext.Provider>;
}

export function useAppI18n(): I18nContextValue{
  const value=useContext(AppI18nContext);
  if(!value)throw new Error("AppI18nProvider is missing");
  return value;
}

export function LanguageSwitcher({compact=false}:{compact?:boolean}){
 const{locale,setLocale,t}=useAppI18n();
 return(
  <div className={`v2-language-switch ${compact?"compact":""}`} aria-label={t("footer.language")}>
   {(["tr","de","en"]as AppLocale[]).map(code=>
    <button
     key={code}
     type="button"
     className={locale===code?"selected":""}
     aria-pressed={locale===code}
     onClick={()=>setLocale(code)}
     title={t(`language.${code}`as I18nKey)}
    >
     {code.toUpperCase()}
    </button>
   )}
  </div>
 );
}
